const state = () => ({
    previewBox:null,
    added:false
});

const mutations =
    {

        setCrossSeller(state, request)
        {
            state.previewBox = request;
        },
        setItemAdded(state, request)
        {
            state.added = true;
        }
    };
const actions = {};
const getters = {};

export default
{
    state,
    mutations,
    actions,
    getters
};
